export class YesNoTag {
    readonly id: number;
    readonly description: string;

    private constructor(id: number, description: string) {
        this.id = id;
        this.description = description;
    }

    public static Yes = new YesNoTag(3302, "yes");
    public static No = new YesNoTag(3303, "no");

    public static asArray = () => [YesNoTag.Yes, YesNoTag.No];

    public static fromId = (id: number) =>
        YesNoTag.asArray().find(t => t.id === id);

    public isYes = () =>
        this === YesNoTag.Yes;

    public isNo = () =>
        this === YesNoTag.No;
}
